export default {"src":"/_next/static/media/ID_v2.1e5c4492.svg","height":35,"width":53,"blurWidth":0,"blurHeight":0};